/**
 * Manufacturer warranty and support pages — ONE list for every warranty
 * surface (/warranty, the warranty coverage lookup, the warranty expiration
 * calculator). FRIDGE-1250 moved it here from app/warranty/page.tsx so the
 * tools link the same verified pages instead of restating any maker's terms.
 *
 * Owner rule 09/18/2026: never restate another company's warranty as a
 * Fridge.com claim. FRIDGE-1122, owner answer 09/24/2026: "Remove those
 * promises. Explain coverage types and link to each manufacturer's exact
 * terms."
 */

export interface MakerTermsLink {
  brand: string
  href: string
  label: string
}

// FRIDGE-1122 — the maker's own warranty or support page, never a restatement
// of its terms. Every URL was opened and answered 200 on 09/26/2026 (the
// Whirlpool-family and Frigidaire sites refuse scripted fetches, so those were
// read in a browser). Maytag and Frigidaire link a dedicated warranty page from
// their own support hubs; Whirlpool and KitchenAid publish no standalone
// warranty page (the statement ships with each model's literature), so they
// link their owner centers and are labelled as support, not as terms.
// Shoppers of every other brand get the same instruction in the copy.
export const MAKER_TERMS_LINKS: MakerTermsLink[] = [
  { brand: 'Samsung', href: 'https://www.samsung.com/us/support/warranty/', label: 'Samsung warranty information' },
  { brand: 'LG', href: 'https://www.lg.com/us/support/warranty-information', label: 'LG warranty information' },
  { brand: 'GE Appliances', href: 'https://www.geappliances.com/ge/service-and-support/', label: 'GE Appliances service and support' },
  { brand: 'Bosch', href: 'https://www.bosch-home.com/us/en/services', label: 'Bosch service and support' },
  { brand: 'Frigidaire', href: 'https://www.frigidaire.com/en/warranty/warranty-information', label: 'Frigidaire warranty information' },
  { brand: 'Maytag', href: 'https://www.maytag.com/services/limited-10-year-warranty.html', label: 'Maytag warranty information' },
  { brand: 'Whirlpool', href: 'https://www.whirlpool.com/owners.html', label: 'Whirlpool owner support' },
  { brand: 'KitchenAid', href: 'https://www.kitchenaid.com/owners.html', label: 'KitchenAid owner support' },
];

/** The instruction for every brand without a verified link above. */
export const ANOTHER_BRAND_INSTRUCTION =
  "Open the support or owner section of the maker's own site and enter your model number."

/** Select value for "Another brand" in the tools' brand pickers. */
export const ANOTHER_BRAND = 'Another brand'

export function makerTermsLinkFor(brand: string): MakerTermsLink | undefined {
  return MAKER_TERMS_LINKS.find((m) => m.brand === brand)
}
